import { ref } from 'vue'
import { functions, httpsCallable } from '@/firebase/config'

// add admin cloud function
const error = ref(null)

const newUserCredential = async (newCredential) => {
  error.value = null
  const createCredential = httpsCallable(functions, 'createCredential')

  createCredential({ newCredential }).then(result => {
    console.log(result)
  }).catch((error) => {
    // Getting the Error details.
    const code = error.code
    const message = error.message
    const details = error.details
    error.value = code + message + details
    // ...
  })
}
// Call updateUser.js
const useCreateNew = () => {
  return { error, newUserCredential }
}

export default useCreateNew
